import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, ReferenceLine } from 'recharts';
import { cleanFilter, updateFilter } from '../../redux/actions/filtroAction';
import ambiente from '../../config/ambienteConfig';
import Filtro from '../relatorios/Filtro';

class CCustos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            receitas: [],
            despesas: [],
            saldo: [],
        };
    }

    componentDidMount = () => {
        this.updateGrafico();
    }

    updateGrafico = async () => {
        const filtro = this.props.filtro;
        const dataFormatada = filtro.data.format('YYYYMM');
        const query = filtro.filtroMensal? `&mes=${dataFormatada}$` : '';
        const res = await axios.get(`${ambiente.dev.server}/relatorios/ccustos?considerarPendentes=${filtro.considerarPendentes}${query}`);
        res.data.despesas.forEach(item => item.total = Math.abs(item.total));
        this.setState({ receitas: res.data.receitas, despesas: res.data.despesas, saldo: res.data.saldo });
    }

    render() {
        return (
            <div>
                <Filtro data mes pendentes atualizar={this.updateGrafico} />
                <div>
                    <BarChart width={1000} height={300} data={this.state.saldo}
                    margin={{top: 5, right: 30, left: 20, bottom: 5}} >
                        <XAxis dataKey="nome" />
                        <YAxis />
                        <CartesianGrid stoke="#ccc" strokeDasharray="5 5"/>
                        <Bar dataKey="total" fill="#32ba3d" />
                        <Tooltip cursor={false}/>
                    </BarChart>
                </div>
                <div className="row">
                    <BarChart width={500} height={300} data={this.state.receitas} >
                        <XAxis dataKey="nome" />
                        <YAxis />
                        <CartesianGrid stoke="#ccc" strokeDasharray="5 5"/>
                        <Bar dataKey="total" fill="#7aadff" />
                        <ReferenceLine y={0} stroke="#000"/>
                        <Tooltip cursor={false}/>
                    </BarChart>
                    <BarChart width={500} height={300} data={this.state.despesas} >
                        <XAxis dataKey="nome" />
                        <YAxis />
                        <CartesianGrid stoke="#ccc" strokeDasharray="5 5"/>
                        <Bar dataKey="total" fill="#ffaf7a" />
                        <ReferenceLine y={0} stroke="#000"/>
                        <Tooltip cursor={false}/>
                    </BarChart>
                </div>
            </div>
        );
    }
}

CCustos.propTypes = {
    updateFilter: PropTypes.func.isRequired,
    cleanFilter: PropTypes.func.isRequired,
    filtro: PropTypes.object.isRequired
  };
  
  function mapStateToProps({filtro}) {
    return {
        filtro: filtro
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      updateFilter: filtro => dispatch(updateFilter(filtro)),
      cleanFilter: () => dispatch(cleanFilter())
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(CCustos);



// WEBPACK FOOTER //
// ./src/components/graficos/CCustos.js